export default __webpack_public_path__ + "static/media/home_portfolios_message_board.ebc104eb.jpg";